import { getCurrentPageTypeFromUrl } from 'Utilities/CurrentPage/currentPageUtils'

const fitmentSegmentEventNames = {
  SEGMENT_FITMENT_ADDED: "Fitment Added",
  SEGMENT_FITMENT_REMOVED: "Fitment Removed",
};

const createFitmentAddedSegmentEvent = (
  makeId,
  make,
  modelId,
  model,
  year,
  raceTypeId,
  raceType
) => {
  return {
    event: fitmentSegmentEventNames.SEGMENT_FITMENT_ADDED,
    properties: {
      make_id: makeId,
      make,
      model_id: modelId,
      model,
      year,
      race_type_id: raceTypeId,
      race_type: raceType,
      page_type: getCurrentPageTypeFromUrl()
    },
  };
};

const createFitmentRemovedSegmentEvent = (
  makeId,
  make,
  modelId,
  model,
  year,
  raceTypeId,
  raceType,
  pageTypeOverride
) => {
  return {
    event: fitmentSegmentEventNames.SEGMENT_FITMENT_REMOVED,
    properties: {
      make_id: makeId,
      make,
      model_id: modelId,
      model,
      year,
      race_type_id: raceTypeId,
      race_type: raceType,
      page_type: getCurrentPageTypeFromUrl()
    },
  };
};

export { createFitmentAddedSegmentEvent, createFitmentRemovedSegmentEvent };
